import React, {useEffect} from 'react';
import {clearState, getUser, setLoginState} from "../store/actions";
import {useDispatch} from "react-redux";
import {useNavigate } from 'react-router-dom';

const LoginFilter = props => {

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {

    // useEffectで非同期関数を呼び出す
    (async () => {
      await loginCheck();
    })();
    
  }, [])
  
  const loginCheck = async () => {
    const response = await dispatch(getUser())
    .then(res => {
      return res;
    }).catch(err => {
      navigate("/login")
    });

    if (response == 'error') {

      // ログアウト処理
      dispatch(setLoginState(false));
      dispatch(clearState());

      navigate("/login")
    }

    return response
  }
  
  
  
  return (
    <>
    </>
  )
}

export default LoginFilter;
